import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Inject,
    Input,
    OnInit,
    Output,
    PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import intlTelInput, { Iti } from 'intl-tel-input';

const defaultUtilScript =
    'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/23.0.1/js/utils.js';

@Directive({
    selector: '[fnTelInput]',
})
export class FnTelInput implements OnInit {
    @Input() fnTelInputOptions: { [key: string]: any } = {};

    @Output() hasError: EventEmitter<boolean> = new EventEmitter();

    @Output() fnTelOutput: EventEmitter<any> = new EventEmitter();

    @Output() countryChange: EventEmitter<any> = new EventEmitter();

    @Output() fnTelInputObject: EventEmitter<any> = new EventEmitter();

    ngTelInput: Iti;

    constructor(
        private el: ElementRef,
        @Inject(PLATFORM_ID) private platformId: string
    ) { }

    ngOnInit() {
        if (isPlatformBrowser(this.platformId)) {
            this.fnTelInputOptions = {
                ...this.fnTelInputOptions,
                utilsScript: this.getUtilsScript(this.fnTelInputOptions),
                separateDialCode: true,
                dropdownContainer: this.el.nativeElement.parentNode,
                formatOnDisplay: false,
                formatAsYouType: false
            };
            this.ngTelInput = intlTelInput(this.el.nativeElement, {
                ...this.fnTelInputOptions,
            });

            this.el.nativeElement.addEventListener('countrychange', () => {
                this.countryChange.emit(this.ngTelInput.getSelectedCountryData());
                this.hasError.emit(this.isInputValid());
            });

            this.fnTelInputObject.emit(this.ngTelInput);
        }
    }

    @HostListener('blur') onBlur() {
        const isInputValid: boolean = this.isInputValid();
        if (isInputValid) {
            const telOutput = this.ngTelInput.getNumber();
            this.hasError.emit(isInputValid);
            this.fnTelOutput.emit(telOutput);
        } else {
            this.hasError.emit(isInputValid);
        }
    }

    isInputValid(): boolean {
        return this.ngTelInput.isValidNumber();
    }

    setCountry(country: any) {
        this.ngTelInput.setCountry(country);
    }

    getUtilsScript(options: any) {
        return options.utilsScript || defaultUtilScript;
    }
}
